import { CREATE, CREATE_SUCCESS, CREATE_ERROR, RESET_SUCCESS } from './actions';

const initial = {
  pending: false,
  error: false,
  success: false
};

const create = state => ({
  ...state,
  pending: true,
  success: false
});

const createSuccess = state => ({
  ...state,
  pending: false,
  success: true
});

const onError = (state, { error }) => ({
  ...state,
  error,
  pending: false,
  success: false
});

const resetSuccess = state => ({
  ...state,
  pending: false,
  success: false
});

export default (state = initial, action) => {
  const reducer = {
    [CREATE]: create,
    [CREATE_SUCCESS]: createSuccess,
    [CREATE_ERROR]: onError,
    [RESET_SUCCESS]: resetSuccess
  }[action.type];

  return reducer ? reducer(state, action) : state;
};
